import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'lib/i18n'
import styles from './auth.scss'
import { setOpenedSubmenu, setAppModule, changeAuthState, createConfirmationToken, validateConfirmationToken, cleanAccountConfirmation,
    setAccountConfirmationStep, createNewClient, checkIfClientExistApi, refreshHashAndTokenApi } from 'state/actions'
import { hasErrors } from '../../state/actions/api'
import { checkIfIE } from '../../state/actions'
const _ = i18n('accountConfirmation')

@connect(state => ({
    hash: state.auth.confirmation.hash,
    step: state.auth.confirmation.step,
    isSending: state.auth.confirmation.isSending,
    isToken: state.auth.confirmation.isToken,
    errors: state.auth.errors
}))
class AccountConfirmation extends Component {

    constructor(props) {
        super(props)
        this.state = {
            smsToken: '',
            smsError: false,
            password: '',
            confirmPassword: '',
            loadingToken: false,
            saveError: '',
            error: {
                smsError: false,
                password: false,
                confirmPassword: false,
                passwordMismatch: false,
            }
        }
    }

    createToken() {
        const { dispatch, hash } = this.props

        if (!hash || hash === '' || hash === null) {
            dispatch(changeAuthState(null))
        }

        dispatch(createConfirmationToken(hash))
    }

    refreshHashAndToken() {
        const { dispatch, hash } = this.props
        dispatch(refreshHashAndTokenApi(hash)).then(response => {
            if(response.success){
                this.setState({ saveError: 'client_registration_link_renewed' })
            }
        })
    }

    checkIfClientExists = () => {
        const { dispatch, hash } = this.props
        dispatch(checkIfClientExistApi(hash))
            .then(res => {
                if (res == false) {
                    dispatch(setAppModule('NEWS'))
                    dispatch(changeAuthState(''))
                    dispatch(cleanAccountConfirmation())
                }
                if (res === 'hash_expired') {
                    this.setState({ saveError: 'client_registration_link_expired' })
                    dispatch(setAccountConfirmationStep(5))
                }
            })
    }

    sendConfirmAccount = (ev) => {
        ev.preventDefault()
        const { step, dispatch, hash } = this.props
        const { smsToken } = this.state

        if (step === 1) {
            dispatch(validateConfirmationToken(hash, smsToken)).then((response) => {
                if (response === true) {
                    dispatch(setAccountConfirmationStep(2))
                } else {
                    this.setState({ error: { smsError: true } })
                }
            })
        }

        if (step === 2) {
            const { password, confirmPassword } = this.state
            const regex = /^(?=[^0-9])(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])(?=.*[_\-$%.!:<>*#%])[a-zA-Z0-9_\-$.!:<>*#%]{8,}$/
            if (hash) {
                if (!regex.test(password)) {
                    dispatch(hasErrors('passwordRulesError'))
                    return
                }

                if (password !== confirmPassword) {
                    dispatch(hasErrors('checkConfirmPassword'))
                    return
                }

                dispatch(createNewClient(password, hash))
                    .then(res => {
                        switch (res[0].error) {
                            case 0:
                                dispatch(setAccountConfirmationStep(3))
                                break;
                            case 1:
                                this.setState({ saveError: 'client_registration_error_email_exists' })
                                dispatch(setAccountConfirmationStep(4))
                                break;
                            case 2:
                                this.setState({ saveError: 'client_registration_error_user_not_created' })
                                dispatch(setAccountConfirmationStep(4))
                                break;
                            case 3:
                                this.setState({ saveError: 'client_registration_error_opt_out_not_registered' })
                                dispatch(setAccountConfirmationStep(4))
                                break;
                        }
                    })
            }
        }

        if (step === 3 || step === 4 || step === 5) {
            dispatch(setAppModule('NEWS'))
            dispatch(changeAuthState(''))
            dispatch(cleanAccountConfirmation())
        }
    }

    handleSmsTokenChange = (event) => {
        this.setState({ smsToken: event.target.value })
    }

    handlePasswordChange = (event) => {
        this.setState({ password: event.target.value })
    }

    handleConfirmPasswordChange = (event) => {
        this.setState({ confirmPassword: event.target.value })
    }
    componentDidMount(prevProps, prevState) {
        this.checkIfClientExists()
    }

    render() {
        const { errors, step } = this.props
        return (
            <div className={styles.authFormsContainer}>
                <div className={styles.loginForm}>
                    <div className={styles.formImage}>
                        <img src={require("resources/easinsure/easinsure-logotype-slogan.svg")} />
                    </div>
                    {step === 1 &&
                        <div className={styles.info}>
                            <p>{_('smsTokenMessage')}</p>
                        </div>
                    }
                    <form onSubmit={(ev) => this.sendConfirmAccount(ev)} method="post" className={styles.form}>

                        {step === 1 &&
                            <div>
                                <div className={styles.formGroup}>
                                    <label>
                                        {_('smsToken')}
                                        <input type="text" name="confirmSmsToken" value={this.state.smsToken} onChange={(ev) => this.handleSmsTokenChange(ev)} />
                                    </label>
                                </div>
                                <div className={styles.errorMessage}>
                                    {this.state.error.smsError && _('smsTokenNotValid')}
                                </div>

                                <div className={styles.formGroup}>
                                    <button className={styles.submitButton}>{_('next')}</button>
                                </div>
                            </div>
                        }

                        {step === 2 &&
                            <div>
                                <div className={styles.info}>
                                    {_('passwordRules')}
                                </div>
                                <div className={styles.formGroup}>
                                    <label>
                                        {_('password')}
                                        <input
                                            ref="password" type="password" name="password"
                                            value={this.state.password}
                                            onChange={(ev) => this.handlePasswordChange(ev)}
                                        />
                                    </label>
                                    <label>
                                        {_('confirmPassword')}
                                        <input
                                            ref="confirmPassword" type="password" name="confirmPassword"
                                            value={this.state.confirmPassword}
                                            onChange={(ev) => this.handleConfirmPasswordChange(ev)}
                                        />
                                    </label>
                                </div>

                                <div className={styles.errorMessage}>
                                    {errors && _(errors.id)}
                                </div>

                                <div className={styles.formGroup}>
                                    <button className={styles.accountConfirmationSubmitButton}>{_('confirmPassword')}</button>
                                </div>
                            </div>
                        }

                        {step === 3 &&
                            <div>
                                <p>{_('passwordSetMessage')}</p>

                                <div className={styles.formGroup}>
                                    <button className={styles.accountConfirmationSubmitButton}>{_('goToLoginBtn')}</button>
                                    {/* </a> */}
                                </div>

                            </div>
                        }

                        {step === 4 &&
                            <div>
                                <div className={styles.info}>
                                    <p>{_(this.state.saveError)}</p>
                                </div>
                                <div className={styles.formGroup}>
                                    {/* <a href={link}> */}
                                    <button className={styles.accountConfirmationSubmitButton}>{_('goToLoginBtn')}</button>
                                    {/* </a> */}
                                </div>

                            </div>
                        }
                        {step === 5 &&
                            <div>
                                <div className={styles.info}>
                                    <p>{_(this.state.saveError)}</p>
                                </div>
                                <div className={styles.formGroup}>
                                    <button className={styles.accountConfirmationSubmitButton}>{_('goToLoginBtn')}</button>
                                </div>
                            </div>
                        }
                    </form>
                </div>
                {
                    step === 1 &&
                    <div id="casper_smsForgot" className={styles.additionalOption}>
                        <a onClick={(e) => this.createToken(e)}>{_('sendCodeMSG')}</a>
                    </div>
                }
                {
                    step === 5 &&
                    <div id="casper_smsForgot" className={styles.additionalOption}>
                        <a onClick={(e) => this.refreshHashAndToken(e)}>{_('refresh_link')}</a>
                    </div>
                }
            </div >
        )
    }
}

export default AccountConfirmation



// WEBPACK FOOTER //
// ./components/auth/accountConfirmation.jsx